import type { AuthProvider } from "@refinedev/core";
import { axiosInstance } from "./utils/data-provider/utils";
import { IContact } from "./utils/zod/contactFormValidation";

export const authProvider: AuthProvider = {
  login: async ({ otp, session_id }) => {
    const response = await axiosInstance.post(`${import.meta.env.VITE_REST_API_URL}/auth/login`, {
        otp, 
        session_id
    });

    if (response.status === 200) {
      localStorage.setItem("token", response.data.token);
      return {
        success: true,
        redirectTo: "/",
      };
    } else {
      return {
        success: false,
        error: {
          statusCode: response.status,
          message: response.data.error || "Login failed",
        },
      };
    }
  },
  register: async ({ email, password }) => {
    try {
      await authProvider.login({ email, password });
      return {
        success: true,
      };
    } catch (error) {
      return {
        success: false,
        error: {
          message: "Register failed",
          name: "Invalid email or password",
        },
      };
    }
  },
  logout: async () => {
    const response = await axiosInstance.delete(`${import.meta.env.VITE_REST_API_URL}/auth/logout`,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
    localStorage.removeItem("token");
    delete axiosInstance.defaults.headers.common["Authorization"];
    return {
      success: true,
      message: response.data.message,
      redirectTo: "/login",
    };
  },
  onError: async (error) => {
    console.error(error);
    return { error };
  },
  check: async () => {
    const token = localStorage.getItem("token");
    if (token) {
      axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      return {
        authenticated: true,
      };
    }

    return {
      authenticated: false,
      error: {
        message: "Check failed",
        name: "Token not found",
      },
      logout: true,
      redirectTo: "/login",
    };
  },
  getPermissions: async () => null,
  getIdentity: async (): Promise<IContact | null> => {

    const token = localStorage.getItem("token");
    if (!token) return null;
    
    const response = await axiosInstance.get(`${import.meta.env.VITE_REST_API_URL}/accounts/me`);

    return response.data;
  },
};
